// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__zSTUo","main-image":"Header_main-image__2Q3So","bg":"Header_bg__UIFHp","foodPlate":"Header_foodPlate__3-qyz"};